﻿'use strict';

angular.module('ntmApp').factory('ListGridDragging', function () {

    function ListGridDragging(dragObj) {

        var self = this;

        self.isDraggable = function () {
            return dragObj && dragObj.enable;
        };

        self.getSequenceField = function () {
            return dragObj ? dragObj.sequenceField : null;
        };

        self.compareSequenceField = function (field) {
            return self.isDraggable() && dragObj.sequenceField === field;
        };

    }

    return (ListGridDragging);
});